// extracted by mini-css-extract-plugin
module.exports = {"root":"CouponQuickBetSwitch_root__3BsOu","toggleControlLabel":"CouponQuickBetSwitch_toggleControlLabel__yaNZ7"};